import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense } from "react";

const MemberProfileRailBar = lazyWithRetry(() =>
  import(/* webpackChunkName: "RailbarMemberProfile" */ "./index").then(
    module => ({ default: module.MemberProfileRailBar }),
  ),
);

/**
 * Lazy so the profile tree stays off the chat shell graph until requested. The
 * fallback is empty because this renders next to the chat, not inside the rail:
 * the panel itself only exists once the portal below mounts.
 */
export const LazyMemberProfileRailBar = () => (
  <Suspense fallback={null}>
    <MemberProfileRailBar />
  </Suspense>
);
